<template>
  <svg width="130" height="130" viewBox="0 0 172 172" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M86.0001 28.6667C54.3521 28.6667 28.6667 54.3521 28.6667 86.0001C28.6667 117.648 54.3521
        143.333 86.0001 143.333C117.648 143.333 143.333 117.648 143.333 86.0001C143.333 54.3521
        117.648 28.6667 86.0001 28.6667ZM74.5334 114.667L45.8667 86.0001L53.9507 77.9161L74.5334
        98.4414L118.049 54.9254L126.133 63.0667L74.5334 114.667Z"
        fill="#038375"
    />
    </svg>
</template>

<script>
export default {
  name: 'icon-sucesso'
}
</script>

<style>
</style>
